import React from 'react';
import PropTypes from 'prop-types';

import { snakeCase, includes } from 'lodash';

import { FormattedHTMLMessage } from 'component-utilities/intl';
import { TextLabel } from 'v-c/Widgets/Components';
import { FormLabel } from 'v-c/Forms';
import PlusBlueIcon from 'v-c/Icons/PlusBlueIcon';

import styles from './dialogSelector.scss';

const BASE_KEY = 'components.templates.edit_user';

export default function DialogSelector({
    getMessage,
    list,
    onOpenModal,
    selectedValues,
    widgetId,
}) {
    const addButtonText = getMessage('components.buttons.add');
    const manageButtonText = getMessage('components.buttons.manage');
    const dataValue = selectedValues.join(', ');
    const rolesCount = String(selectedValues.length);
    const rolesList = list
        .filter(({ id }) => includes(selectedValues, id))
        .map(({ value }) => value)
        .join(', ');

    return (
        <div className="dialog-selector" data-dialog-selector={snakeCase(widgetId)}>
            <FormLabel required>
                <FormattedHTMLMessage id={`${BASE_KEY}.roles`} values={{ rolesCount }} />
            </FormLabel>
            {!selectedValues.length && (
                <TextLabel className={styles['add-label']} data-action="add" onClick={onOpenModal}>
                    <PlusBlueIcon className="plus-icon" />
                    {'\u00A0'}
                    {addButtonText}
                </TextLabel>
            )}
            {!!selectedValues.length && (
                <TextLabel className={styles['manage-label']} data-action="manage" onClick={onOpenModal}>
                    {'\u00A0'}
                    {manageButtonText}
                </TextLabel>
            )}
            {!!selectedValues.length && (
                <TextLabel
                    className={styles['selected-list']}
                    data-field="selected-roles"
                    data-value={dataValue}
                    onClick={onOpenModal}
                >
                    {rolesList}
                </TextLabel>
            )}
        </div>
    );
}

DialogSelector.displayName = 'RolesDialogSelector';

DialogSelector.propTypes = {
    getMessage: PropTypes.func.isRequired,
    list: PropTypes.array.isRequired,
    onOpenModal: PropTypes.func,
    selectedValues: PropTypes.array.isRequired,
    widgetId: PropTypes.string.isRequired,
};

DialogSelector.defaultProps = {
    onOpenModal: () => {},
};
